export default "__VITE_ASSET__d0b4c75e__"